import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import PacketAllocationCreate from "./PacketAllocationCreate";
import ToastModal from "views/components/ToastModal";
import { useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import { packetAllocationTableColumns } from "assets/properties/properties";
import { packetSizes } from "assets/properties/properties";
import FindStructureData from "helper/FindStructureType";
import { sortByString } from "utils/Utils";

const PacketAllocation = (props) => {
  const [selectedTableData, setSelectedTableData] = useState([]);
  const { classes, featureFlagState } = props;
  const [rawData, setRawData] = useState([]);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [confirmationModal1, setConfirmationModal1] = useState(false);
  const [confirmationModalHeader1, setConfirmationModalHeader1] = useState("");
  const [confirmationModalMsg1, setConfirmationModalMsg1] = useState("");
  const [deletePacketAllocation, setDeletePacketAllocation] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [packetAllocationShow, setPacketAllocationShow] = useState(true);
  const [dataPacketNumberFrom, setDataPacketNumberFrom] = useState("");
  const [dataPacketNumberTo, setDataPacketNumberTo] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [callInProgress, setCallInProgress] = useState(false);
  const outletData = useOutletContext();
  const [preFixName, setPreFixName]= useState(false);
  const skipPacketAllocationDeleteFlag = parseAndSetFlag(outletData?.skipPacketAllocationDeleteFlag);
   const [structureTypeData, setStructureTypeData]= useState([]);
   const [branchList, setBranchList] = useState([]);
   useEffect(()=>{
      FindStructureData(apiHandler,endpoint,authToken, setStructureTypeData)
  },[])
    useEffect(()=>{
      getBranchList();
    },[structureTypeData]);
    const getBranchList = async () => {
      let branchCodes = structureTypeData.filter((b) => b.branchType === true);
      if (branchCodes.length > 0) {
        branchCodes.forEach(async (branch) => {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.MASTER_HIERARCHY_FIND_BY_TYPE_CODE + branch?.code,
        authToken: authToken,
      });
      setCallInProgress(false);
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
      } else {
        const sortedArray = sortByString(result?.data, 'name', true);
        setBranchList(sortedArray);
        GetData(sortedArray);
      }
    })
  }
    };
  const GetData = async (sortedArray) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PACKET_ALLOCATION_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data, sortedArray);
    }
  };
  const packetSizeList = typeof featureFlagState?.packetSizesList !== "undefined" ? JSON.parse(featureFlagState?.packetSizesList) : packetSizes;

  // parseIndicatedData function
  const parseIndicatorData = (data, sortedArray) => {
    let reportData = [];
    data.forEach((packet, i) => {
        const packetSizeName = packetSizeList?.filter((item)=> item?.code === packet?.size);
        const matchedBranch = sortedArray?.find(
          (item) => item?.code === packet?.branchCode
        );
      let row = {
        branch: packet.branchCode,
        branchName: matchedBranch?.name,
        packetSize: packetSizeName?.[0]?.name || packet.size,
        from: `${packet?.prefix ? packet?.prefix : ''}${packet.serialStartNo}`,
        to: `${packet?.prefix ? packet?.prefix : ''}${packet.serialEndNo}`,
        weight: packet.packetWeight,
        action: getIcons(packet.id, packet.serialStartNo, packet.serialEndNo, packet?.prefix),
      };
      reportData.push(row);
    });
    reportData.sort((a, b) =>
      (a?.branchName || "").localeCompare(b?.branchName || "")
    );
    setSelectedTableData(reportData);
  };
  // icons function calling
  const getIcons = (code, packetFrom, packetTo, preFixName) => {
    return (
      <>
        <IconButton
          aria-label="Edit_Packet"
          onClick={() => onClickEditData(code, packetFrom, packetTo, preFixName)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete_Packet"
          onClick={() => onClickDeleteData(code)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  const onClickEditData = (code, packetFrom, packetTo, preFixName) => {
    setDeletePacketAllocation(code);
    setPacketAllocationShow(false);
    setDataPacketNumberTo(packetTo);
    setDataPacketNumberFrom(packetFrom);
    setPreFixName(preFixName)
  };

  // delete function
  const onClickDeleteData = (code) => {
    setConfirmationModalHeader("Packet Allocation");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeletePacketAllocation(code);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeletePacketAllocation("");
  };

  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete Branch
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PACKET_ALLOCATION_DELETE + deletePacketAllocation,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      onErrorDeleteData(deletePacketAllocation);
    } else {
      toastUpdate("Success", "Packet Allocation deleted successful", true);
      GetData(branchList);
    }
  };
    const onErrorDeleteData = (code) => {
      setConfirmationModalHeader1('Packet Allocation');
      setConfirmationModalMsg1("Packets are allocated from this series. Do you still want to delete it?");
      setDeletePacketAllocation(code);
      setConfirmationModal1(true);
    };
     const handleNegativeResponse1 = () => {
    setConfirmationModal1(false);
    setConfirmationModalHeader1("");
    setConfirmationModalMsg1("");
    setDeletePacketAllocation("");
  };
    const handlePositiveResponse1 = async () => {
    handleNegativeResponse1();
    // Call API to delete Branch
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PACKET_ALLOCATION_DELETE + deletePacketAllocation + `?skipValidation=true`,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Packet Allocation deleted successful", true);
      GetData(branchList);
    }
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };

  const onCloseModal = (type) => {
    if (type === "create") {
      toastUpdate("Success", "Packet Allocation created successfully", true);
    } else {
      toastUpdate("Success", "Packet Allocation updated successfully", true);  
    }
    GetData(branchList);
  };
  const onSearchChange = (event) => {
    const val = event.target.value;
    const filteredData = rawData.filter((row) => {
      const matchedBranch = branchList?.find(
        (item) => item?.code === row?.branchCode
      );
      return (
        row?.size?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.branchCode?.toLowerCase()?.includes(val?.toLowerCase()) ||
        matchedBranch?.name?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.serialStartNo?.toString()?.includes(val) ||
        row?.serialEndNo?.toString()?.includes(val)
      );
    });

    parseIndicatorData(filteredData, branchList);
  };
  return (
    <GridContainer>
      {packetAllocationShow ? (
        <>
          <GridItem xs={12} sm={12} md={12}>
            <SubHeader label="Packet Allocation" 
               onSearchChange={onSearchChange}
               searchLabel="Search For Allocation Packet"
               search
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <ColumnGroupingTable
              columns={packetAllocationTableColumns}
              rows={selectedTableData}
            />
          </GridItem>
        </>
      ) : (
        <PacketAllocationCreate
          packetAllocationShow={setPacketAllocationShow}
          packetId={deletePacketAllocation}
          setPacketId={setDeletePacketAllocation}
          classes={classes}
          closeModal={onCloseModal}
          dataPacketNumberTo={dataPacketNumberTo}
          dataPacketNumberFrom={dataPacketNumberFrom}
          preFix={preFixName}
          dataPacketSize
        />
      )}
     {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
      <ConfirmationModal
        confirmationModal={confirmationModal1}
        confirmationModalHeader={confirmationModalHeader1}
        confirmationModalMsg={confirmationModalMsg1}
        handleNegativeButton={handleNegativeResponse1}
        handlePositiveButton={handlePositiveResponse1}
      />
    </GridContainer>
  );
};

PacketAllocation.propTypes = {
  classes: PropTypes.object,
};

export default PacketAllocation;
